import React from "react";
import { useNavigate } from "react-router-dom";
import {
  UilShoppingCart,
  UilCheckCircle,
  UilClock,
  UilCalendarAlt,
  UilBox,
  UilSun,
} from "@iconscout/react-unicons";

const Card = ({ currencySymbol, ...rest }) => {
  return <ModernCard param={rest} currencySymbol={currencySymbol} />;
};

function ModernCard({ param, currencySymbol }) {
  const totalCount = param.series[0]?.data[0] || 0;
  const navigate = useNavigate();

  const handleClick = () => {
    if (param.link) {
      navigate(param.link);
    }
  };

  // Get icon based on param.icon or title
  const getIcon = () => {
    const iconType = param.icon || "";
    switch (iconType) {
      case "shopping":
        return UilShoppingCart;
      case "check":
        return UilCheckCircle;
      case "clock":
        return UilClock;
      case "calendar":
        return UilCalendarAlt;
      case "box":
        return UilBox;
      case "today":
        return UilSun;
      default:
        return UilShoppingCart;
    }
  };

  const Icon = getIcon();

  return (
    <div
      className={`${param.color || "bg-white border-gray-200"} rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer`}
      onClick={handleClick}
    >
      {/* Icon */}
      <div className="flex items-center justify-between mb-4">
        <div className="p-2 bg-gray-100 rounded-lg">
          <Icon size={24} className="text-gray-600" />
        </div>
      </div>

      {/* Count */}
      <div className="mb-2">
        <h2 className="font-display font-bold text-3xl text-gray-900">
          {param.title.includes("Sales")
            ? `${currencySymbol}${Number(totalCount).toFixed(2)}`
            : param.title.includes("Rating")
              ? `${totalCount}/5`
              : totalCount.toLocaleString()}
        </h2>
      </div>

      {/* Title */}
      <p className="font-text text-sm font-medium text-gray-600">
        {param.title}
      </p>
    </div>
  );
}

export default Card;
